/* eslint-disable react-hooks/exhaustive-deps */
// -- == //
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';

import PrimaryButton from 'components/form/buttons/primaryButton';
import OutlineButton from 'components/form/buttons/outLineButton';
import TextIput from 'components/form/textInput';
import { useActions } from 'common/hooks/useActions';
import TextArea from 'components/form/texArea';

import NotificationUserMultiDropdown from '../multiDropdown';
import NoticationUserTable from '../../../table';
import { useNavigate } from 'react-router-dom';

import * as S from '../../styles';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import { ValidationCreateSendUserNotif } from 'common/validations';

interface IProps {
  data?: any;
  userList: any[];
}

const NotificationCreateSendToUserForm: React.FC<IProps> = ({ data, userList }) => {
  const nav = useNavigate();
  const [userSearchValue, setUserSearchValue] = useState<string | undefined>('');

  const { userList: users } = useTypedSelector((state) => state.Users);
  const { notficationCreateCustomRequestAction, usersRequestAction } = useActions();

  useEffect(() => {
    usersRequestAction({});
  }, []);

  useEffect(() => {
    usersRequestAction({ search: userSearchValue });
  }, [userSearchValue]);

  return (
    <Formik
      initialValues={{
        title: data?.title || '',
        body: data?.body || '',
        sendToAll: false,
        users: []
      }}
      enableReinitialize
      validationSchema={ValidationCreateSendUserNotif}
      onSubmit={(values, { setSubmitting }) => {
        const newData = {
          ...values,
          users: values.users.map((item: any) => item.id)
        };
        notficationCreateCustomRequestAction(newData, () => {
          nav('/panel/notifications');
        });
        setSubmitting(false);
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setValues }) => (
        <>
          <S.Body>
            <S.Grid2>
              <S.Rows>
                <TextIput
                  type="text"
                  name="title"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Notification title"
                  label="Title"
                  required
                  value={values.title}
                  message={touched.title && (errors.title as any)}
                  error={touched.title && (errors.title as unknown as boolean)}
                />

                <TextArea
                  label="Message"
                  required
                  name="body"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="What should people see?"
                  value={values.body}
                  message={touched.body && (errors.body as any)}
                  error={touched.body && (errors.body as unknown as boolean)}
                  help="Sent as a push notification. Keep it under two lines."
                />
              </S.Rows>

              <S.Rows>
                <NotificationUserMultiDropdown
                  label="Recipients"
                  list={userList}
                  placeholder="Search or select people"
                  defaultValues={values.users}
                  onChange={(list: any) => {
                    setValues({ ...values, users: list as any });
                  }}
                  onChangeValue={(val?: string) => setUserSearchValue(val)}
                  loading={users.loading}
                  message={touched.users && (errors.users as any)}
                  error={touched.users && (errors.users as unknown as boolean)}
                />

                <div>
                  <S.SubHead>{`Selected · ${values.users.length}`}</S.SubHead>
                  <NoticationUserTable data={values.users} setValues={setValues} values={values} />
                </div>
              </S.Rows>
            </S.Grid2>
          </S.Body>

          <S.Actions>
            <OutlineButton link="/panel/notifications">Cancel</OutlineButton>
            <PrimaryButton onClick={handleSubmit}>Send notification</PrimaryButton>
          </S.Actions>
        </>
      )}
    </Formik>
  );
};

export default NotificationCreateSendToUserForm;
